import { createUseQueryHook } from './createUseQueryHook';

export const usePersonDetailPublic = createUseQueryHook('get_person');
